module.exports = __webpack_public_path__ + "img/小街道.c813f5ec.jpg";